import { getLastMonthDateRange } from '~/utils/date';
import { IFormValues } from '../types';

const getInitialValues = (): IFormValues => ({
  healthManagerIds: [],
  ...getLastMonthDateRange(),
});

export default getInitialValues;
